import { Outlet } from 'react-router-dom';
import Navbar from '@ui/components/Navbar/Navbar';
import Footer from '@ui/components/Footer/Footer';
import AuthModal from '@ui/components/AuthModal/AuthModal';
import BetaBanner from '@ui/components/BetaBanner/BetaBanner';
import AppInstallBanner from '@ui/components/AppInstallBanner/AppInstallBanner';
import { logEvent } from '../../infra/firebase/analytics';
import { AnalyticsEvent } from '../../domain/analytics';
import styles from './RootLayout.module.css';

export default function RootLayout() {
  return (
    <div className={styles.root}>
      <AppInstallBanner
        onView={() => logEvent(AnalyticsEvent.appBannerView)}
        onCtaClick={() => logEvent(AnalyticsEvent.appBannerClick)}
        onDismiss={() => logEvent(AnalyticsEvent.appBannerDismiss)}
      />
      <BetaBanner />
      <Navbar />
      <main className={styles.main}>
        <Outlet />
      </main>
      <Footer />
      <AuthModal />
    </div>
  );
}
